import makeStyles from '@mui/styles/makeStyles';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(({
  note: {
    textAlign: 'center',
    marginTop: 16,
    fontSize: 12,
    color: '#6B7280',
  },
}));

export const ContactSupportText = () => {
  const classes = useStyles();
  const intl = useIntl();

  const successEmail = <a target="_blank" href="mailto: success@katalon.com" rel="noreferrer">Contact Support</a>;

  return (
    <p className={classes.note}>
      {
        intl.formatMessage({ id: 'page.checkout.payment.confirmation.note' }, {
          email: 'business@katalon.com',
          a: () => successEmail,
        })
      }
    </p>
  );
};
